export function stringify(obj) {
  if (!obj) return '';
  const params = new URLSearchParams();
  Object.keys(obj).forEach((k) => {
    const v = obj[k];
    // Skip undefined/null
    if (v === undefined || v === null) return;
    // If value is an array, append multiple entries
    if (Array.isArray(v)) {
      v.forEach(val => params.append(k, String(val)));
    } else {
      params.append(k, String(v));
    }
  });
  return params.toString();
}

export function parse(str) {
  if (!str) return {};
  // accept leading ?
  const s = str.charAt(0) === '?' ? str.substring(1) : str;
  const params = new URLSearchParams(s);
  const out = {};
  for (const [k, v] of params.entries()) {
    // if key already exists, convert to array
    if (Object.prototype.hasOwnProperty.call(out, k)) {
      if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    } else {
      out[k] = v;
    }
  }
  return out;
}

export default { stringify, parse };
